import { render, staticRenderFns } from "./UADashboard.vue?vue&type=template&id=213df584"
import script from "./UADashboard.vue?vue&type=script&lang=js"
export * from "./UADashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports